// src/components/common/LoadingFallback.jsx

/**
 * Componente de fallback para Suspense (lazy loading)
 * Muestra un spinner elegante mientras se cargan los componentes
 */
export default function LoadingFallback() {
  const isDark = true;

  const colors = {
    bg: isDark ? '#0a0a0f' : '#f5f5f5',
    spinnerPrimary: '#fbbf24',
    spinnerSecondary: '#ea580c',
    text: isDark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)',
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: colors.bg,
      gap: '1.5rem',
    }}>
      {/* Spinner animado */}
      <div style={{
        width: 60,
        height: 60,
        border: `4px solid ${isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
        borderTop: `4px solid ${colors.spinnerPrimary}`,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }} />

      {/* Texto de carga */}
      <p style={{
        color: colors.text,
        fontSize: '0.95rem',
        fontWeight: 500,
        margin: 0,
      }}>
        Cargando...
      </p>

      {/* CSS para la animación */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
